import { gql } from '@apollo/client';

export const CREATE_HOTEL_MUTATION = gql`
  mutation CreateHotel($data: createHotelInput!) {
    createHotel(input: $data) {
      hotel {
        id
        name
        subdomain
        code
        theme {
          id
        }
      }
    }
  }
`;
